import { render, staticRenderFns } from "./DoctorPatientsView.vue?vue&type=template&id=22c81170&scoped=true"
import script from "./DoctorPatientsView.vue?vue&type=script&lang=js"
export * from "./DoctorPatientsView.vue?vue&type=script&lang=js"
import style0 from "./DoctorPatientsView.vue?vue&type=style&index=0&id=22c81170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c81170",
  null
  
)

export default component.exports